<script setup lang="ts">
import { computed } from 'vue';
import { getCurrentLocale } from '@/i18n';
import { getTextVariant } from '@/utils/stringUtils';
import AutoComplete from 'primevue/autocomplete';
import Fluid from 'primevue/fluid';

interface Props {
  optionAir: any;
  filterReturningTo: any;
  filterReturningFrom: any;
  isShowError: boolean;
}
const props = defineProps<Props>();

const emits = defineEmits<{
  'update:optionAir': [value: any];
  'update:filterReturningTo': [value: any];
  'update:filterReturningFrom': [value: any];
  'update:isShowError': [value: boolean];
  searchReturningFrom: [event: any];
  searchReturningTo: [event: any];
  clearReturningFrom: [];
  clearReturningTo: [];
}>();

const option = computed({
  get() {
    return props.optionAir;
  },
  set(value) {
    emits('update:optionAir', value);
  }
});

const currentLanguage = getCurrentLocale();

const onSearchReturningFrom = (event: any) => {
  emits('searchReturningFrom', event);
};

const onSearchReturningTo = (event: any) => {
  emits('searchReturningTo', event);
};

const onClearReturningFrom = () => {
  emits('clearReturningFrom');
};

const onClearReturningTo = () => {
  emits('clearReturningTo');
};
</script>
<template>
  <div class="air-return-form grid">
    <div class="col-12 sm:col-6">
      <Fluid>
        <div class="field returning-from-list">
          <label for="returning-from">{{ $t('advance_quote.form.returning_from') }}</label>
          <div class="flex align-items-center">
            <AutoComplete
              v-model="option.returningFrom"
              :suggestions="filterReturningFrom"
              @complete="onSearchReturningFrom($event)"
              :optionLabel="getTextVariant(currentLanguage, 'airportNameEn', 'airportNameFr')"
              :class="isShowError && !option.returningFrom ? 'p-invalid' : ''"
              class="w-full"
              forceSelection
              completeOnFocus
              id="returningFrom"
            >
              <template #option="slotProps">
                <div class="flex align-options-center">
                  <div>
                    <div>{{ getTextVariant(currentLanguage, slotProps.option.airportNameEn, slotProps.option.airportNameFr) }} ({{ slotProps.option.airportCode }})</div>
                    <div class="text-xs">
                      {{ getTextVariant(currentLanguage, slotProps.option.cityNameEn, slotProps.option.cityNameFr) }}, {{ (slotProps.option.province ?? currentLanguage == 'en') ? slotProps.option.regionEn : slotProps.option.regionFr }},
                      {{ getTextVariant(currentLanguage, slotProps.option.countryNameEn, slotProps.option.countryNameFr) }}
                    </div>
                  </div>
                </div>
              </template>
            </AutoComplete>
            <div>
              <i class="clear-return-from pi pi-times-circle ml-2 text-red-500 cursor-pointer" @click="onClearReturningFrom()"></i>
            </div>
          </div>
          <span class="text-red-500" v-if="isShowError && !option.returningFrom"> {{ $t('validate.required') }} </span>
        </div>
      </Fluid>
    </div>
    <div class="col-12 sm:col-6">
      <Fluid>
        <div class="field returning-to-list flex-col">
          <label for="returning-to">{{ $t('advance_quote.form.returning_to') }}</label>
          <div class="flex align-items-center">
            <AutoComplete
              v-model="option.returningTo"
              :suggestions="filterReturningTo"
              @complete="onSearchReturningTo($event)"
              :optionLabel="getTextVariant(currentLanguage, 'airportNameEn', 'airportNameFr')"
              :class="isShowError && !option.returningTo ? 'p-invalid' : ''"
              class="w-full"
              forceSelection
              completeOnFocus
              id="returningTo"
            >
              <template #option="slotProps">
                <div class="flex align-options-center">
                  <div>
                    <div>{{ getTextVariant(currentLanguage, slotProps.option.airportNameEn, slotProps.option.airportNameFr) }} ({{ slotProps.option.airportCode }})</div>
                    <div class="text-xs">
                      {{ getTextVariant(currentLanguage, slotProps.option.cityNameEn, slotProps.option.cityNameFr) }}, {{ (slotProps.option.province ?? currentLanguage == 'en') ? slotProps.option.regionEn : slotProps.option.regionFr }},
                      {{ getTextVariant(currentLanguage, slotProps.option.countryNameEn, slotProps.option.countryNameFr) }}
                    </div>
                  </div>
                </div>
              </template>
            </AutoComplete>
            <div>
              <i class="clear-return-to pi pi-times-circle ml-2 text-red-500 cursor-pointer" @click="onClearReturningTo()"></i>
            </div>
          </div>
          <span class="text-red-500" v-if="isShowError && !option.returningTo"> {{ $t('validate.required') }} </span>
        </div>
      </Fluid>
    </div>
  </div>
</template>
